(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activateTab(root, index) {
    var tabs = root.querySelectorAll('[data-comparison-tab]');
    var panels = root.querySelectorAll('[data-comparison-panel]');
    if (!tabs.length || !panels.length) return;
    for (var i = 0; i < tabs.length; i++) {
      var on = i === index;
      tabs[i].classList.toggle('is-active', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      var label = tabs[i].querySelector('.comparison-table__tab-label');
      if (label && root.dataset.tabActive && root.dataset.tabInactive) {
        label.style.color = on ? root.dataset.tabActive : root.dataset.tabInactive;
      }
      if (panels[i]) {
        panels[i].classList.toggle('is-active', on);
        panels[i].hidden = !on;
      }
    }
  }

  function initComparison(root) {
    if (!root || root.dataset.comparisonReady) return;
    root.dataset.comparisonReady = 'true';
    var tabs = root.querySelectorAll('[data-comparison-tab]');
    var defaultIdx = parseInt(root.getAttribute('data-default-tab'), 10);
    if (isNaN(defaultIdx)) defaultIdx = 0;
    if (defaultIdx < 0 || defaultIdx >= tabs.length) defaultIdx = 0;
    activateTab(root, defaultIdx);
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activateTab(root, i);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-comparison-root]').forEach(initComparison);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var el = document.getElementById('shopify-section-' + ev.detail.sectionId);
    if (el) {
      el.querySelectorAll('[data-comparison-root]').forEach(function (root) {
        delete root.dataset.comparisonReady;
        initComparison(root);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__online-retailers"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-sb-online-section]');
  if (!root) return;
  const carousel = root.querySelector('[data-sb-online-carousel]');
  if (!carousel) return;

  const dataEl = document.getElementById('sb-stockists-data');
  let data = { stockists: [], online: [] };
  try { data = JSON.parse(dataEl.textContent); } catch (e) { console.warn('Stockist data parse error', e); }

  const logosEl = root.querySelector('[data-sb-online-logos]');
  let logoMap = {};
  try { logoMap = JSON.parse(logosEl.textContent); } catch (e) { /* no logos = OK */ }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // Map of country code/name → display country shown on cards.
  function shortCountry(c) {
    const map = {
      'AU': 'AU', 'Australia': 'AU',
      'NZ': 'NZ', 'New Zealand': 'NZ',
      'ZA': 'ZA', 'South Africa': 'ZA',
      'US': 'US', 'United States': 'US',
      'GB': 'UK', 'UK': 'UK', 'United Kingdom': 'UK'
    };
    return map[c] || (c || '').toUpperCase();
  }

  // Group everything by `stockist` (brand) so 16 Baby on the Move stores
  // become a single card with a count, not 16 cards.
  const groups = new Map();
  function add(item, isOnline) {
    const brand = (item.stockist || item.name || '').trim();
    if (!brand) return;
    let g = groups.get(brand);
    if (!g) {
      g = {
        name: brand,
        country: shortCountry(item.country),
        website: item.website || '',
        retailCount: 0,
        onlineCount: 0,
        firstSuburb: '',
        firstState: ''
      };
      groups.set(brand, g);
    }
    if (isOnline) g.onlineCount += 1;
    else g.retailCount += 1;
    if (!g.website && item.website) g.website = item.website;
    if (!g.firstSuburb && item.suburb) g.firstSuburb = item.suburb;
    if (!g.firstState && item.state) g.firstState = item.state;
  }
  (data.stockists || []).forEach(function (s) { add(s, false); });
  (data.online || []).forEach(function (o) { add(o, true); });

  function whereLabel(g) {
    // Single physical location → suburb · state
    if (g.retailCount === 1 && g.onlineCount === 0 && g.firstSuburb) {
      return g.firstSuburb + (g.firstState ? ' · ' + g.firstState : '');
    }
    // Multiple physical locations
    if (g.retailCount > 1) return g.retailCount + ' locations';
    // Online only
    if (g.onlineCount > 0 && g.retailCount === 0) return 'Online';
    return '';
  }

  function typeLabel(g) {
    if (g.onlineCount > 0 && g.retailCount === 0) return g.country ? 'Online · ' + g.country : 'Online';
    return g.country || '';
  }

  // Stable, file-system-friendly key for naming logo files later
  // (e.g. "Baby On The Move" → "baby-on-the-move").
  function brandKey(name) {
    return String(name || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  carousel.innerHTML = Array.from(groups.values())
    .sort(function (a, b) { return (a.name || '').localeCompare(b.name || ''); })
    .map(function (g) {
    const tag = g.website ? 'a' : 'div';
    const linkAttrs = g.website
      ? ' href="' + escapeHtml(g.website) + '" target="_blank" rel="noopener"'
      : '';
    const where = whereLabel(g);
    const type = typeLabel(g);
    const key = brandKey(g.name);
    const logoUrl = logoMap[key] || '';
    const logoHtml = logoUrl
      ? '<img src="' + escapeHtml(logoUrl) + '" alt="' + escapeHtml(g.name) + ' logo" loading="lazy">'
      : '';
    return '<' + tag + ' class="sb-online__card" data-brand="' + escapeHtml(key) + '"' + linkAttrs + '>' +
      '<div class="sb-online__body">' +
        '<div class="sb-online__name">' + escapeHtml(g.name) + '</div>' +
        (where ? '<div class="sb-online__where">' + escapeHtml(where) + '</div>' : '') +
        (type ? '<span class="sb-online__type">' + escapeHtml(type) + '</span>' : '') +
      '</div>' +
      '<div class="sb-online__logo" data-brand-logo="' + escapeHtml(key) + '">' + logoHtml + '</div>' +
    '</' + tag + '>';
  }).join('');

  // Carousel nav arrows
  const prev = root.querySelector('[data-sb-online-prev]');
  const next = root.querySelector('[data-sb-online-next]');
  function step() {
    const card = carousel.querySelector('.sb-online__card');
    if (!card) return 280;
    const styles = getComputedStyle(carousel);
    const gap = parseInt(styles.gap, 10) || 14;
    return card.getBoundingClientRect().width + gap;
  }
  if (prev) prev.addEventListener('click', function () {
    carousel.scrollBy({ left: -step() * 2, behavior: 'smooth' });
  });
  if (next) next.addEventListener('click', function () {
    carousel.scrollBy({ left: step() * 2, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__store-locator"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-sb-locator]');
  if (!root) return;

  const dataEl = document.getElementById('sb-stockists-data');
  const logosEl = document.querySelector('[data-sb-locator-logos]');
  let locatorLogoMap = {};
  try { locatorLogoMap = JSON.parse(logosEl.textContent); } catch (e) { /* no logos OK */ }
  function brandKey(name) {
    return String(name || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  let data = { stockists: [], online: [] };
  try { data = JSON.parse(dataEl.textContent); } catch (e) { console.warn('Stockist data parse error', e); }

  const stockists = (data.stockists || []).filter(function (s) {
    return s.lat != null && s.lng != null;
  });

  const forms = root.querySelectorAll('[data-sb-form]');
  const inputs = root.querySelectorAll('[data-sb-input]');
  const errorEl = root.querySelector('[data-sb-error]');
  const listHead = root.querySelector('[data-sb-listhead]');
  const scroll = root.querySelector('[data-sb-scroll]');
  const mapEl = root.querySelector('[data-sb-map]');

  const pinColor = root.dataset.pinColor || '#C97B63';
  const pinInner = root.dataset.pinInner || '#FFFFFF';
  const originColor = root.dataset.originColor || '#2F2A26';

  let map = null;
  let markers = {};
  let originMarker = null;
  let origin = null;
  let activeKey = null;

  const PIN_SVG = '<svg width="30" height="38" viewBox="0 0 30 38" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M15 0C6.7 0 0 6.7 0 15c0 11.3 15 23 15 23s15-11.7 15-23C30 6.7 23.3 0 15 0z" fill="' + pinColor + '"/>' +
    '<circle cx="15" cy="15" r="6" fill="' + pinInner + '"/></svg>';

  // ---- AU + NZ suburb/postcode dataset, lazy-loaded once on first input ----
  // Each row: ["Suburb", "State/Region", "Postcode"]. We tag each row with
  // its country at load time so a single scored-match call covers both.
  let suburbList = null; // null = not loaded yet, [] = load failed
  let suburbListPromise = null;
  function loadSuburbList() {
    if (suburbListPromise) return suburbListPromise;
    const auUrl = root.dataset.auPostcodes;
    const nzUrl = root.dataset.nzPostcodes;
    suburbListPromise = Promise.all([
      auUrl ? fetch(auUrl).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; }) : Promise.resolve([]),
      nzUrl ? fetch(nzUrl).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; }) : Promise.resolve([])
    ]).then(function (results) {
      const au = (results[0] || []).map(function (r) { return [r[0], r[1], r[2], 'Australia']; });
      const nz = (results[1] || []).map(function (r) { return [r[0], r[1], r[2], 'New Zealand']; });
      suburbList = au.concat(nz);
      return suburbList;
    });
    return suburbListPromise;
  }
  function isSuburbListLoaded() { return suburbList !== null; }

  // ---- Brand index (one entry per `stockist` value) ----
  // Each brand picks up the bounding box of its stores so a "Baby Bunting"
  // pick zooms to the cluster instead of dropping us on a single shop.
  const brandsByName = new Map();
  stockists.forEach(function (s) {
    const brand = String(s.stockist || s.name || '').trim();
    if (!brand) return;
    let b = brandsByName.get(brand);
    if (!b) {
      b = { name: brand, count: 0, lat: s.lat, lng: s.lng, stores: [] };
      brandsByName.set(brand, b);
    }
    b.count += 1;
    b.stores.push(s);
  });
  const brands = Array.from(brandsByName.values());

  // ---- Score-based fuzzy match (mirrors the PDP shipping card logic) ----
  function scoreSuburb(row, qLower, qDigits) {
    const subLower = (row[0] || '').toLowerCase();
    const pc = String(row[2] || '');
    let s = 0;
    if (qDigits && pc.indexOf(qDigits) === 0) s += 100;
    else if (qDigits && pc.indexOf(qDigits) >= 0) s += 30;
    if (qLower) {
      if (subLower === qLower) s += 200;
      else if (subLower.indexOf(qLower) === 0) s += 80;
      else if (subLower.indexOf(qLower) >= 0) s += 20;
    }
    return s;
  }
  function scoreText(text, qLower) {
    const t = (text || '').toLowerCase();
    if (!t || !qLower) return 0;
    if (t === qLower) return 250;
    if (t.indexOf(qLower) === 0) return 130;
    if (t.indexOf(qLower) >= 0) return 50;
    return 0;
  }

  function fmtSuburb(row) {
    const pc = row[2] || '';
    return row[0] + ', ' + row[1] + (pc ? ' ' + pc : '');
  }

  // Combined suggestions across stores, brands, and AU/NZ suburbs.
  // Returns up to 8 items, each: { score, type, label, pickValue, ...payload }
  function getSuggestions(q) {
    if (!q || q.length < 2) return [];
    const qLower = q.toLowerCase();
    const qDigits = q.replace(/\D/g, '');
    const scored = [];

    // 1) Individual stores (e.g. "Baby Bunting Thomastown")
    stockists.forEach(function (s) {
      const sc = scoreText(s.name, qLower);
      if (sc > 0) {
        scored.push({
          score: sc,
          type: 'store',
          label: s.name,
          pickValue: s.name,
          stockist: s
        });
      }
    });

    // 2) Brands (e.g. "Baby Bunting (52 stores)")
    brands.forEach(function (b) {
      const sc = scoreText(b.name, qLower);
      if (sc > 0) {
        // Bump brand score down slightly so an exact store match wins over
        // its parent brand when both score the same way.
        scored.push({
          score: sc - 5,
          type: 'brand',
          label: b.count > 1 ? (b.name + ' · ' + b.count + ' stores') : b.name,
          pickValue: b.name,
          brand: b
        });
      }
    });

    // 3) AU/NZ suburbs + postcodes (only if the dataset has loaded)
    if (suburbList && suburbList.length) {
      for (let i = 0; i < suburbList.length; i++) {
        const sc = scoreSuburb(suburbList[i], qLower, qDigits);
        if (sc > 0) {
          const label = fmtSuburb(suburbList[i]);
          scored.push({
            score: sc,
            type: 'suburb',
            label: label,
            pickValue: label,
            country: suburbList[i][3]
          });
        }
      }
    }

    scored.sort(function (a, b) { return b.score - a.score; });

    // Dedupe by pickValue so brand + store with the same name (e.g. a
    // single-location brand like "Toyworld Berri") doesn't render twice.
    const seen = new Set();
    const out = [];
    for (let i = 0; i < scored.length && out.length < 8; i++) {
      const key = scored[i].type + '|' + scored[i].pickValue.toLowerCase();
      // Also collapse store+brand sharing the same display value
      const dedupKey = scored[i].pickValue.toLowerCase();
      if (seen.has(dedupKey)) continue;
      seen.add(dedupKey);
      out.push(scored[i]);
    }
    return out;
  }

  const SUGGEST_PIN_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';

  function renderSuggestionsInto(box, matches) {
    if (!box) return;
    if (!matches.length) {
      box.setAttribute('data-open', 'false');
      box.innerHTML = '';
      return;
    }
    let html = '';
    for (let i = 0; i < matches.length; i++) {
      const m = matches[i];
      const safe = escapeHtml(m.label);
      const safePick = escapeHtml(m.pickValue);
      html += '<button type="button" class="sb-locator__suggest-item" role="option"' +
        ' data-sb-pick="' + safePick + '"' +
        ' data-sb-pick-type="' + m.type + '"' +
        ' data-sb-pick-display="' + safe + '">' +
        SUGGEST_PIN_SVG + '<span>' + safe + '</span></button>';
    }
    box.innerHTML = html;
    box.setAttribute('data-open', 'true');
  }
  function renderLoadingInto(box) {
    if (!box) return;
    box.innerHTML = '<div class="sb-locator__suggest-item sb-locator__suggest-loading">' + SUGGEST_PIN_SVG + '<span>Loading…</span></div>';
    box.setAttribute('data-open', 'true');
  }

  function refreshSuggestions(input) {
    const wrap = input.closest('[data-sb-inputwrap]');
    const box = wrap ? wrap.querySelector('[data-sb-suggest]') : null;
    if (!box) return;
    const q = input.value.trim();
    if (!q || q.length < 2) {
      renderSuggestionsInto(box, []);
      return;
    }
    // Stockists + brands match instantly. Suburb list adds matches once loaded.
    renderSuggestionsInto(box, getSuggestions(q));
    if (!isSuburbListLoaded()) {
      loadSuburbList().then(function () {
        const current = input.value.trim();
        if (current.length >= 2) renderSuggestionsInto(box, getSuggestions(current));
      });
    }
  }

  function closeAllSuggestions() {
    root.querySelectorAll('[data-sb-suggest]').forEach(function (box) {
      box.setAttribute('data-open', 'false');
      box.innerHTML = '';
    });
  }

  function findLocalMatch(query) {
    const raw = query.trim();
    if (!raw) return null;
    const q = raw.toLowerCase();
    // Pure postcode → match by postcode
    if (/^\d{3,4}$/.test(q)) {
      const hit = stockists.find(function (s) { return String(s.postcode || '').trim() === q; });
      if (hit) return { lat: hit.lat, lng: hit.lng };
    }
    // "Suburb, STATE postcode" (picked from the dropdown) → split + match
    const m = raw.match(/^(.+?),\s*([A-Za-z' ]+?)(?:\s+(\d{3,4}))?$/);
    if (m) {
      const suburb = m[1].toLowerCase();
      const pc = (m[3] || '').toLowerCase();
      const hit = stockists.find(function (s) {
        const sameSub = String(s.suburb || '').toLowerCase() === suburb;
        if (!sameSub) return false;
        if (pc && String(s.postcode || '').toLowerCase() !== pc) return false;
        return true;
      });
      if (hit) return { lat: hit.lat, lng: hit.lng };
    }
    // Bare suburb name → match a stockist with same suburb
    const hit2 = stockists.find(function (s) {
      return String(s.suburb || '').toLowerCase() === q;
    });
    if (hit2) return { lat: hit2.lat, lng: hit2.lng };
    return null;
  }

  function lookupInDataset(query) {
    if (!suburbList || !suburbList.length) return null;
    const q = query.trim().toLowerCase();
    if (!q) return null;
    for (let i = 0; i < suburbList.length; i++) {
      const r = suburbList[i];
      const sub = (r[0] || '').toLowerCase();
      const pc = String(r[2] || '');
      const fmt = fmtSuburb(r).toLowerCase();
      if (fmt === q || sub === q || pc === q) {
        return { suburb: r[0], state: r[1], postcode: r[2], country: r[3] };
      }
    }
    return null;
  }

  function keyFor(s) { return s.name + '|' + s.postcode; }

  function haversineKm(a, b) {
    const R = 6371;
    const toRad = function (d) { return d * Math.PI / 180; };
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const lat1 = toRad(a.lat);
    const lat2 = toRad(b.lat);
    const h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function fullAddress(s) {
    const parts = [s.address1, s.address2, s.suburb, s.state, s.postcode].filter(Boolean);
    return parts.join(', ');
  }

  function initMap() {
    if (typeof L === 'undefined') {
      // Leaflet still loading — retry shortly
      return setTimeout(initMap, 100);
    }
    map = L.map(mapEl, {
      center: [-32.5, 145],
      zoom: 4,
      zoomControl: true,
      scrollWheelZoom: false
    });
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(map);

    const pinIcon = L.divIcon({
      className: 'sb-locator__pin',
      html: PIN_SVG,
      iconSize: [30, 38],
      iconAnchor: [15, 38],
      popupAnchor: [0, -34]
    });

    stockists.forEach(function (s) {
      const m = L.marker([s.lat, s.lng], { icon: pinIcon }).addTo(map);
      const websiteLink = s.website
        ? '<a class="sb-locator__popup-link" href="' + escapeHtml(s.website) + '" target="_blank" rel="noopener">Visit website</a>'
        : '';
      m.bindPopup(
        '<span class="sb-locator__popup-name">' + escapeHtml(s.name) + '</span>' +
        '<span class="sb-locator__popup-addr">' + escapeHtml(fullAddress(s)) + '</span>' +
        websiteLink
      );
      m.on('click', function () { setActive(keyFor(s)); });
      markers[keyFor(s)] = m;
    });

    renderList();
  }

  function renderList() {
    const sorted = origin
      ? stockists.map(function (s) {
          return Object.assign({}, s, {
            distance: haversineKm(origin, { lat: s.lat, lng: s.lng })
          });
        }).sort(function (a, b) { return a.distance - b.distance; })
      : stockists.slice().sort(function (a, b) {
          return (a.name || '').localeCompare(b.name || '');
        });

    const listCount = parseInt(root.dataset.listCount, 10) || 0;
    const visible = (listCount > 0 && origin) ? sorted.slice(0, listCount) : sorted;

    if (listHead) {
      listHead.textContent = origin
        ? visible.length + ' stockists, nearest first'
        : sorted.length + ' stockists';
    }

    scroll.innerHTML = '';
    visible.forEach(function (s) {
      const k = keyFor(s);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sb-locator__card' + (k === activeKey ? ' is-active' : '');
      btn.setAttribute('data-key', k);
      const dist = (s.distance != null)
        ? '<span class="sb-locator__dist">' + s.distance.toFixed(1) + ' km</span>'
        : '';
      const phone = s.phone
        ? '<p class="sb-locator__phone">' + escapeHtml(s.phone) + '</p>'
        : '';
      const logoUrl = locatorLogoMap[brandKey(s.stockist || s.name)] || '';
      const logoHtml = logoUrl
        ? '<img src="' + escapeHtml(logoUrl) + '" alt="' + escapeHtml(s.stockist || s.name) + ' logo" loading="lazy">'
        : '';
      btn.innerHTML =
        '<div class="sb-locator__cardgrid">' +
          '<div class="sb-locator__cardbody">' +
            '<div class="sb-locator__cardrow">' +
              '<h3>' + escapeHtml(s.name) + '</h3>' + dist +
            '</div>' +
            '<p class="sb-locator__addr">' + escapeHtml(fullAddress(s)) + '</p>' +
            phone +
          '</div>' +
          '<div class="sb-locator__cardlogo">' + logoHtml + '</div>' +
        '</div>';
      btn.addEventListener('click', function () { focusStockist(s); });
      scroll.appendChild(btn);
    });
  }

  function setActive(k) {
    activeKey = k;
    scroll.querySelectorAll('.sb-locator__card').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-key') === k);
    });
  }

  function focusStockist(s) {
    const k = keyFor(s);
    setActive(k);
    if (!map) return;
    map.flyTo([s.lat, s.lng], 13, { duration: 0.6 });
    const m = markers[k];
    if (m) m.openPopup();
    // Scroll active card into view on mobile
    if (window.matchMedia('(max-width: 798px)').matches) {
      mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  async function geocodePostcode(pc, country) {
    const cacheKey = 'sb_pc_' + country + '_' + pc;
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) return JSON.parse(cached);
    } catch (e) {}
    const url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' +
      encodeURIComponent(pc + ', ' + country);
    const res = await fetch(url, { headers: { 'Accept-Language': 'en' } });
    if (!res.ok) return null;
    const arr = await res.json();
    if (!arr || !arr.length) return null;
    const coords = { lat: parseFloat(arr[0].lat), lng: parseFloat(arr[0].lon) };
    try { sessionStorage.setItem(cacheKey, JSON.stringify(coords)); } catch (e) {}
    return coords;
  }

  function placeOrigin(coords) {
    origin = coords;
    if (!map) return;
    map.flyTo([coords.lat, coords.lng], 12, { duration: 0.8 });
    if (originMarker) originMarker.remove();
    const originIcon = L.divIcon({
      className: 'sb-locator__pin',
      html: '<div style="width:18px;height:18px;border-radius:50%;background:' + originColor + ';border:3px solid ' + pinInner + ';box-shadow:0 0 0 3px rgba(47,42,38,0.18);"></div>',
      iconSize: [18, 18],
      iconAnchor: [9, 9]
    });
    originMarker = L.marker([coords.lat, coords.lng], { icon: originIcon }).addTo(map);
  }

  async function search(e) {
    if (e) e.preventDefault();
    const query = (inputs[0] && inputs[0].value || '').trim();
    if (!query) return;

    errorEl.hidden = true;
    errorEl.textContent = '';

    // Store name typed (e.g. "Baby Bunting Thomastown") → fly to that store
    const qLower = query.toLowerCase();
    const storeHit = stockists.find(function (s) {
      return (s.name || '').toLowerCase() === qLower;
    });
    if (storeHit) { focusStockist(storeHit); return; }

    // Brand name typed (e.g. "Baby Bunting") → fit map to all of that brand
    const brandHit = brandsByName.get(query) ||
      Array.from(brandsByName.values()).find(function (b) { return b.name.toLowerCase() === qLower; });
    if (brandHit) { focusBrand(brandHit); return; }

    // Try local suburb/postcode match (instant — from our stockist list)
    const localCoords = findLocalMatch(query);
    if (localCoords) {
      placeOrigin(localCoords);
      renderList();
      return;
    }

    try {
      // Enrich the query using the AU/NZ suburb+postcode dataset for sharper Nominatim hits
      const enriched = lookupInDataset(query);
      let coords = null;
      if (enriched) {
        coords = await geocodePostcode(
          enriched.suburb + ', ' + enriched.state + ' ' + enriched.postcode,
          enriched.country
        );
      }
      if (!coords) coords = await geocodePostcode(query, 'Australia');
      if (!coords) coords = await geocodePostcode(query, 'New Zealand');
      if (!coords) {
        errorEl.textContent = "We couldn't find that location. Try a postcode or suburb.";
        errorEl.hidden = false;
      } else {
        placeOrigin(coords);
        renderList();
      }
    } catch (err) {
      console.warn('Postcode search failed', err);
      errorEl.textContent = "Something went wrong. Try again?";
      errorEl.hidden = false;
    }
  }

  // Sync inputs across all forms (hero + sidebar) + suggestions (debounced via rAF)
  let suggestRaf = null;
  inputs.forEach(function (input) {
    input.addEventListener('input', function (e) {
      inputs.forEach(function (other) {
        if (other !== e.target) other.value = e.target.value;
      });
      if (suggestRaf) cancelAnimationFrame(suggestRaf);
      suggestRaf = requestAnimationFrame(function () { refreshSuggestions(input); });
    });
    input.addEventListener('focus', function () {
      // Warm the dataset on first focus so the first keystroke feels instant.
      loadSuburbList();
      if (input.value.trim().length >= 2) refreshSuggestions(input);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllSuggestions();
    });
  });

  function focusBrand(brand) {
    if (!map || !brand || !brand.stores || !brand.stores.length) return;
    const pts = brand.stores
      .filter(function (s) { return s.lat != null && s.lng != null; })
      .map(function (s) { return [s.lat, s.lng]; });
    if (!pts.length) return;
    if (pts.length === 1) {
      map.flyTo(pts[0], 13, { duration: 0.6 });
    } else {
      map.fitBounds(L.latLngBounds(pts), { padding: [60, 60], maxZoom: 11 });
    }
  }

  // Click-to-pick on suggestion items, plus close-on-outside-click
  document.addEventListener('click', function (e) {
    const pick = e.target.closest('[data-sb-pick]');
    if (pick && root.contains(pick)) {
      e.preventDefault();
      const value = pick.getAttribute('data-sb-pick') || '';
      const type = pick.getAttribute('data-sb-pick-type') || 'suburb';
      inputs.forEach(function (i) { i.value = value; });
      closeAllSuggestions();

      if (type === 'store') {
        const s = stockists.find(function (x) { return x.name === value; });
        if (s) focusStockist(s);
        return;
      }
      if (type === 'brand') {
        const b = brandsByName.get(value);
        if (b) focusBrand(b);
        return;
      }
      // Suburb / postcode: existing flow — sets origin, re-sorts list
      search();
      return;
    }
    // Click outside any input wrap closes open dropdowns
    if (!e.target.closest('[data-sb-inputwrap]')) closeAllSuggestions();
  });

  forms.forEach(function (f) { f.addEventListener('submit', search); });

  if (stockists.length === 0) {
    if (listHead) listHead.textContent = 'Stockist data unavailable';
  } else {
    initMap();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
